// extracted by mini-css-extract-plugin
module.exports = {"stepsGrid":"SetupReviewerProfile_stepsGrid__cYPnZ","stepNumber":"SetupReviewerProfile_stepNumber__1YrZz","stepNumberSelected":"SetupReviewerProfile_stepNumberSelected__DFo5j"};